
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    isCurrentColor(item) {
      return item.offer_external_id === this.data.external_id
    },
    changeColor(item) {
      if (this.isCurrentColor(item)) return
      const newPath = this.$route.path
        .split('/')
        .slice(0, -1)
        .concat(item.offer_external_id)
        .join('/')
      this.$router.push(newPath)
    }
  },
}
